import {AfterViewInit, Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {PrimeNGConfig} from "primeng/api";
import {MenuComponent} from "./menu/menu.component";
import {RouterOutlet} from "@angular/router";
import {FooterComponent} from "./footer/footer.component";
import {NgClass, NgIf} from "@angular/common";
import {TopBarComponent} from "./top-bar/top-bar.component";
import {SharedModule} from "../../shared/shared.module";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  standalone: true,
  imports: [
    MenuComponent,
    RouterOutlet,
    FooterComponent,
    NgIf,
    NgClass,
    TopBarComponent,
    // Provide access to non-standalone shared components like <app-spinner>
    SharedModule
  ],
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements AfterViewInit, OnDestroy, OnInit {

  public menuActiveMobile?: boolean;

  public staticMenuInactive: boolean = false;

  public topMenuActive?: boolean;

  documentClickListener?: () => void;

  menuClick?: boolean;

  topMenuButtonClick?: boolean;

  constructor(
    public renderer: Renderer2,
    private primengConfig: PrimeNGConfig
  ) {
  }

  ngOnInit() {
    this.primengConfig.ripple = true;
    document.documentElement.style.fontSize = '14px';
  }

  ngAfterViewInit() {
    this.documentClickListener = this.renderer.listen('body', 'click', (event) => {
      if (!this.isDesktop()) {
        if (!this.menuClick) {
          this.menuActiveMobile = false;
        }

        if (!this.topMenuButtonClick) {
          this.hideTopMenu();
        }
      }

      this.menuClick = false;
      this.topMenuButtonClick = false;
    });
  }

  toggleMenu(event: Event) {
    this.menuClick = true;

    if (this.isDesktop()) {
      this.staticMenuInactive = !this.staticMenuInactive;
    } else {
      this.menuActiveMobile = !this.menuActiveMobile;
      this.topMenuActive = false;
    }

    event.preventDefault();
  }

  toggleTopMenu(event: Event) {
    this.topMenuButtonClick = true;
    this.menuActiveMobile = false;

    if (this.topMenuActive) {
      this.hideTopMenu();
    } else {
      this.topMenuActive = true;
    }

    event.preventDefault();
  }

  hideTopMenu() {
    setTimeout(() => {
      this.topMenuActive = false;
    }, 1);
  }

  isDesktop() {
    return window.innerWidth > 992;
  }

  ngOnDestroy() {
    if (this.documentClickListener) {
      this.documentClickListener();
    }
  }
}
